import type { Filters } from "../types"
import { getCategories } from "./category"
import { filterConfig } from "./filter-config"
import { getDisplayGroup } from "./filter-group-name-map"
import { getSearchText } from "./filter-selection/search-text-data"

export const getFilterContainerElement = () => document.querySelector<HTMLDivElement>(".head-menu")
export const loaderHtmlString = () => '<span class="loading">&nbsp;</span>'

let filters: Filters = {}

export function setFilters(newFilters: Filters) {
    filters = newFilters
}

export function getFilters() {
    return filters
}

export function getGroupedFilters() {
    const grouped: { [key: string]: { values: string[]; groupName: string } } = {}
    for (const group of Object.keys(filters)) {
        for (const value of filters[group]) {
            const displayGroup = getDisplayGroup(group, value)
            if (grouped[displayGroup]) {
                grouped[displayGroup].values.push(value)
            } else {
                grouped[displayGroup] = {
                    groupName: group,
                    values: [value],
                }
            }
        }
    }
    return grouped
}

export function getGroupedFilterKeysService() {
    const grouped = getGroupedFilters()
    return Object.keys(grouped)
        .filter((key) => grouped[key].groupName === "service" && key !== "exklusiv")
        .sort()
}

export function getGroupedFilterKeysContact() {
    const grouped = getGroupedFilters()
    return Object.keys(grouped)
        .filter((key) => filterConfig.groups.contact.includes(grouped[key].groupName))
        .sort()
}

export function getGroupedFilterKeysTraits() {
    const grouped = getGroupedFilters()
    return Object.keys(grouped)
        .filter(
            (key) =>
                !filterConfig.groups.contact.includes(grouped[key].groupName) &&
                grouped[key].groupName !== "service" &&
                grouped[key].groupName !== "exklusiv",
        )
        .sort()
}

export function removeGroupedFilterGroup(displayGroup: string) {
    const grouped = getGroupedFilters()
    const valuesToRemove = grouped[displayGroup].values
    const groupName = grouped[displayGroup].groupName
    filters[groupName] = filters[groupName].filter((val: string) => !valuesToRemove.includes(val))
    if (filters[groupName].length === 0) {
        delete filters[groupName]
    }
}

export function removeFilterGroupValue(group: string, value: string) {
    if (!filters[group]) {
        return
    }
    if (filters[group].length > 1) {
        filters[group] = filters[group].filter((groupValue: string) => groupValue !== value)
    } else {
        delete filters[group]
    }
}

export function addFilterGroupValue(group: string, value: string) {
    if (group in filters) {
        if (!filters[group].includes(value)) filters[group].push(value)
    } else {
        filters[group] = [value]
    }
}

export function setFilterGroupValue(group: string, value: string[]) {
    filters[group] = value
}

export function removeFilterGroup(group: string) {
    delete filters[group]
}

export function getFiltersAsString() {
    return Object.keys(filters)
        .map(
            (group) =>
                `${group}${filterConfig.delimiterGroupValue}${filters[group].join(filterConfig.delimiterValues)}`,
        )
        .join(filterConfig.delimiterGroups)
}

export function isActiveStarsFilter() {
    return (
        getFilters().exklusiv?.includes("mit-stars-content") ||
        getFilters().exklusiv?.includes("mit-premium-beitraegen")
    )
}

export function isAnyFilterActive() {
    return Object.keys(getFilters()).length > 0 || getCategories().length > 0 || !!getSearchText()
}

export function parseFiltersFromLocation() {
    filters = {}

    const pathSegments = location.pathname.split("/")
    const filterString = pathSegments[pathSegments.length - 1]

    // filter string always includes a group delimiter, categories wont include that
    if (filterString?.includes(filterConfig.delimiterGroupValue)) {
        const groupsString = filterString.split(filterConfig.delimiterGroups)
        for (const groupString of groupsString) {
            if (!groupString) {
                continue
            }
            const [group, valuesString] = groupString.split(filterConfig.delimiterGroupValue)
            filters[group] = valuesString.split(filterConfig.delimiterValues)
        }
    }
}

parseFiltersFromLocation()
